import styled from "styled-components";
import { MainFooter } from "@/components/ui/Footer/MainFooter";
import { AircraftSpecifications } from "./AircraftSpecifications";
import { AircraftTypeHeroSection } from "./AircraftTypeHeroSection";
import {
	AircraftComfort,
	AircraftComfortMobile,
	AircraftConfigurationMobile,
	AircraftAmenitiesMobile,
	AircraftConfigurationTablet,
} from "./AircraftComfort";
import { AircraftRequestQuote } from "./AircraftRequestQuote";
import { AircraftRange } from "./AircraftRange";
import { AircraftRangeMobile } from "./AircraftRangeMobile";
import { AircraftImages } from "./AircraftImages";
import { AircraftImagesMobile } from "./AircraftImagesMobile";
import { useEffect, useRef, useState } from "react";
import { RAVideo } from "@/components/customs";
import { AircraftTypeDetailsSnap } from "./AircraftTypeDetailsSnap";
import { AIRCRAFT_RANGE_STEP } from ".";

import { Grid } from "antd";
const { useBreakpoint } = Grid;
export function AircraftTypeDetailsNormal({ aircraftType = {} }) {
	const screens = useBreakpoint();
	const [activeSpecification, setActiveSpecification] = useState(false);
	const [scrollPosition, setScrollPosition] = useState(0);
	const {
		name = "",
		spec_description = "",
		properties = {},
		amenities = {},
		luggages = {},
		background_title = "",
		background_description = "",
		main_button_text = "",
		main_background = {},
		main_background_mobile = {},
		main_background_media_type,
		main_background_video = {},
		seat_maps = [],
		max_range_in_nautical_miles = 0,
		range_routes = [],
		aircraft_list = [],
		banner_desktop = {},
		banner_mobile = {},
		center_airport = {},
		range_title = "",
		range_description = "",
		seat_description = "",
	} = aircraftType || {};

	useEffect(() => {
		const onScroll = () => {
			setScrollPosition(window.scrollY);
			if (window.scrollY > 200) {
				setActiveSpecification(true);
			} else {
				setActiveSpecification(false);
			}
		};

		window.addEventListener("scroll", onScroll);

		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<>
			<div style={{ width: "100%", height: "100vh" }}>
				<AircraftTypeHeroSection
					background={screens?.xs ? banner_mobile : banner_desktop}
					typeName={name || ""}
					className="aircraft-type-hero-image-section"
				/>
			</div>
			<BodySpecificationContainer
				style={{
					// paddingBottom: 60,
					position: "relative",
					top: activeSpecification ? "0px" : screens?.md ? "-120px" : "-80px",
					transition: "all 0.6s linear",
				}}
			>
				<div
					style={{
						transition: "all 0.6s linear",
						width: activeSpecification ? "100vw" : screens?.md ? `${scrollPosition / 10 + 80}vw` : "89vw",
					}}
				>
					<AircraftSpecifications
						description={spec_description}
						active={activeSpecification}
						properties={properties}
					/>
				</div>
			</BodySpecificationContainer>
			<BodyComfort style={{ height: "auto" }}>
				<BodyContainer>
					<AircraftComfortMobile
						amenities={amenities}
						luggages={luggages}
						seatMaps={seat_maps}
						description={seat_description}
						// showComfort={showComfort}
					/>
				</BodyContainer>
			</BodyComfort>
			<BodyComfort>
				<BodyContainer
				// style={{
				//     paddingTop: 100,
				//     paddingBottom: 60,
				// }}
				>
					{screens?.md ? (
						<AircraftConfigurationTablet
							amenities={amenities}
							luggages={luggages}
							seatMaps={seat_maps}
							// showComfort={showComfort}
						/>
					) : (
						<AircraftConfigurationMobile
							amenities={amenities}
							luggages={luggages}
							seatMaps={seat_maps}
							// showComfort={showComfort}
						/>
					)}
				</BodyContainer>
			</BodyComfort>
			{!screens?.md && (
				<BodyComfort>
					<BodyContainer
					// style={{
					//     paddingTop: 100,
					//     paddingBottom: 60,
					// }}
					>
						<AircraftAmenitiesMobile
							amenities={amenities}
							luggages={luggages}
							seatMaps={seat_maps}
							// showComfort={showComfort}
						/>
					</BodyContainer>
				</BodyComfort>
			)}
			<BodyRequestCode background={screens.xs ? main_background_mobile?.url : main_background?.url}>
				<Overlay />
				{main_background_media_type === "VIDEO" ? (
					<div
						style={{
							width: "100%",
							height: "100vh",
						}}
					>
						<RAVideo
							width="100%"
							height="100vh"
							path={
								main_background_video?.url ||
								"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-final.mp4"
							}
						/>
						<BodyContainer
							style={{
								position: "absolute",
								width: "100%",
								height: "100%",
								top: 0,
								left: 0,
							}}
						>
							<AircraftRequestQuote
								title={background_title}
								description={background_description}
								image={main_background}
								image_mobile={main_background_mobile}
								image_media_type={main_background_media_type}
								className="aircraft-type-request-quote-section"
							/>
						</BodyContainer>
					</div>
				) : (
					<BodyContainer>
						<AircraftRequestQuote
							title={background_title}
							description={background_description}
							image={main_background}
							image_mobile={main_background_mobile}
							image_media_type={main_background_media_type}
							className="aircraft-type-request-quote-section"
						/>
					</BodyContainer>
				)}
			</BodyRequestCode>
			<BodyAircraftRange>
				<AircraftRangeMobile
					className="aircraft-type-range-section"
					range={max_range_in_nautical_miles}
					routes={range_routes}
					// step={aircraftRangeStep}
					centerAiport={center_airport}
					description={range_description}
					title={range_title}
				/>
			</BodyAircraftRange>
			<BodyAircraftImages>
				<AircraftImagesMobile
					className="aircraft-type-images-section"
					aircrafts={aircraft_list}
					typeName={name}
				/>
			</BodyAircraftImages>
			<footer
				style={{
					width: "100%",
					scrollSnapAlign: "end",
				}}
			>
				<MainFooter />
			</footer>
		</>
	);
}

const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 120px 136px;
	width: 100%;
	scroll-snap-align: start;
	&.home-utilities-container-outer {
		margin-top: 50px;
	}
	@media (max-width: 991px) {
		padding: 90px 80px;
		&.home-utilities-container-outer {
			margin-top: 40px;
		}
	}
	@media (max-width: 767px) {
		padding: 60px 32px;
		&.home-utilities-container-outer {
			margin-top: 30px;
		}
	}
	@media (max-width: 575px) {
		padding: 40px 20px 40px 20px;
		&.home-utilities-container-outer {
			margin-top: 20px;
		}
	}
`;
const BodyAircraftRange = styled.div`
	width: 100%;
`;
const BodySpecificationContainer = styled.div`
	scroll-snap-align: center;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const BodyComfort = styled.div`
	scroll-snap-align: start;
	width: 100%;
	display: flex;
	justify-content: center;
	background-image: url("/images/example/aircraft/seat-map-background.png");
	height: 100%;
	overflow: hidden;
`;
const BodyRequestCode = styled.div`
	scroll-snap-align: start;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	display: flex;
	justify-content: center;
	background: ${(props) => `url(${props.background}) no-repeat top center`};
	background-size: cover;
	position: relative;
`;
const BodyAircraftImages = styled.div`
	width: 100%;
`;

const Overlay = styled.div`
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background: linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0) 100%);
	opacity: 0.800000011920929;
`;
